import { CollectorEvent } from './types';

export function validate(event: CollectorEvent): boolean {
  return typeof event.event_type === 'string' && event.event_type.trim().length > 0;
}
